import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import type { QnAFormData } from 'src/app/(default)/support/qna/write/_components';
import { cn } from 'src/app/lib/utils/tailwindcss';

const QuestionSection = () => {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<QnAFormData>();

  const watchedMessage = watch('contents') ?? '';

  const messageRegister = register('contents', {
    required: '문의 내용을 입력해주세요',
  });

  const [isFocused, setIsFocused] = useState(false);

  return (
    <div>
      <p className="pb-2 typo-body-2 text-text-caption-label">문의 내용</p>
      <div
        className={cn(
          'relative box-border flex h-[100px] w-full shrink-0 flex-col content-stretch items-start justify-between rounded-lg bg-[#f0f0f0]',
          'py-3',
          'h-[386px]',
          'border border-transparent focus-within:border-k-50',
        )}
      >
        {/* Custom placeholder */}
        {!isFocused && watchedMessage.length === 0 && (
          <div className="pointer-events-none absolute inset-0 px-5 py-3 typo-body-3 whitespace-pre-line text-[#b0b0b0]">
            {'문의 내용을 입력해주세요.'}
          </div>
        )}

        <textarea
          {...messageRegister}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          maxLength={1000}
          className="relative min-h-px w-full min-w-px shrink-0 grow basis-0 resize-none border-none bg-transparent px-5 text-left typo-body-3 text-[#121212] outline-none"
        />
        <div className="relative box-border flex w-full shrink-0 flex-row content-stretch items-center justify-end px-5 pb-0 text-left typo-caption-1 text-nowrap text-[#b0b0b0]">
          <p className="block typo-caption-1 text-nowrap whitespace-pre">{watchedMessage.length}/1000</p>
        </div>
      </div>
      {errors.contents && (
        <p className="pt-2 typo-caption-1 whitespace-pre-line text-rd-50">{errors.contents?.message}</p>
      )}
    </div>
  );
};

export default QuestionSection;
